// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suburbWidget":"SuburbWidget__suburbWidget--9ADpo","chevRight":"SuburbWidget__chevRight--ECl1l"};